<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="8">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.searchKey"
              @keyup.enter="query"
              type="search"
              :placeholder="'Search here...'"
              size="sm"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-danger"
              @click="$emit('batchDel')"
              v-if="allow('D')"
            >
              {{ $l("btn_del_rows") || "批量删除" }}
            </b-button>

            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="
                $emit('openProjectListDialog', { val: 'R', val2: 'selection' })
              "
              v-if="allow('A')"
            >
              {{ $l("btn_add_prj_selection") || "加入项目选品池" }}
            </b-button>

            <b-button
              size="sm"
              class="ml-2"
              variant="outline-info"
              @click="
                $emit('openProjectListDialog', { val: 'R', val2: 'recommend' })
              "
              v-if="allow('M')"
            >
              {{ $l("btn_build_recommend") || "生成推荐单" }}
            </b-button>

            <b-button
              size="sm"
              class="ml-2"
              variant="outline-primary"
              @click="
                $emit('openProjectListDialog', { val: 'R', val2: 'quotation' })
              "
              v-if="allow('B')"
            >
              {{ $l("btn_build_quotation") || "生成报价单" }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
const initForm = {
  searchKey: "",
};

export default {
  data() {
    return {
      form: {
        ...initForm,
      },
    };
  },
  methods: {
    query() {
      this.$emit("submit", this.form);
    },
    onReset() {
      this.form = {
        ...initForm,
      };
      this.$emit("reset");
      this.query();
    },
    fromLoad() {
      this.$emit("add");
    },
  },
  mounted() {
    this.query();
  },
  activated() {
    this.query();
  },
};
</script>
